import { mapState } from "pinia";
import { STATUTS_COMMANDE } from "@/utils/statut-commande";
import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from '@/store/context'
import { useCheckoutStore } from '@/store/checkout'
import { useGtm } from '@gtm-support/vue-gtm';

export const useTransactionFailureTracking = () => {
  const gtm = useGtm();
  const contextStore = useContextStore();
  const checkoutStore = useCheckoutStore();

  const { layout } = storeToRefs(contextStore);
  const { status } = storeToRefs(checkoutStore);

  const trackTransactionFailure = (labelGA) => {
    try {
      gtm.trackEvent({
        event: trackingCodes.PURCHASEKO,
        categoryGA: trackingCodes.CATEGORYGA.ecommerce,
        actionGA: trackingCodes.PURCHASEKO,
        labelGA,
        sitetype: layout.value === LayoutTypes.default ? 'd' : 'm',
        nonInteraction: false
      })
    } catch { }
  }
  return { trackTransactionFailure }
}
